import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
import './stripe.vars.css'


declareVconsoleComponent('stripeLoader', () => import('./components/StripeLoader.vue'), 'stripe_main:payment_form')